import type { LocalInterview } from '@Domain/Ports/LocalInterviews/LocalInterviewPort';

export type LocalInterviewCaptureState = 'capturable' | 'already-captured';

/**
 * A local interview may only ever be captured once. `outboxItemId` is set the moment a queue item
 * exists for it (`LocalInterviewPort.ts`), and its presence is what forbids a second capture: a
 * second session on the same interview would create a second queue item on the same `recordingId`,
 * with segments renumbered from 0 that the server would overwrite by `upsert` — destroying audio
 * already received by the first session. `source` is never read here: an imported interview never
 * reaches this predicate with `outboxItemId === null`, since its queue item is created in the same
 * step as its local record.
 */
const localInterviewCaptureState = (localInterview: LocalInterview): LocalInterviewCaptureState => {
	return localInterview.outboxItemId === null ? 'capturable' : 'already-captured';
};

export default localInterviewCaptureState;
